import React from 'react';
import { Box, Typography, Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';

const DisableSummary = ({ groups, checked, onCheckboxChange, isTouched }) => {
    if (!groups || groups.length === 0) {
        return null;
    }

    // Calculate total affected members
    // const totalMembers = groups.reduce((sum, group) => sum + (group.members?.length || 0), 0);

    return (
        <Box
            sx={{
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                backgroundColor: '#fff',
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px', mb: 2 }}>
                Disable Summary
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {/* Groups to Disable */}
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 500, minWidth: '200px' }}>
                        Groups to Disable:
                    </Typography>
                    <Typography variant="body1">{groups.length}</Typography>
                </Box>

                {/* Total Affected Members */}
                {/*  <Box sx={{ display: 'flex', gap: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 500, minWidth: '200px' }}>
                        Total affected members:
                    </Typography>
                    <Typography variant="body1">{totalMembers}</Typography>
                </Box> */}

                {/* Impact */}
                {/*   <Box sx={{ display: 'flex', gap: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 500, minWidth: '200px' }}>
                        Impact:
                    </Typography>
                    <Typography variant="body1">All members will lose access immediately</Typography>
                </Box> */}

                {/* Confirmation Checkbox */}
                <Box sx={{ mt: 1 }} className={isTouched && !checked ? 'validate' : ''}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checked}
                                onChange={onCheckboxChange}
                                color={isTouched && !checked ? 'error' : 'primary'}
                                sx={{
                                    ...(isTouched &&
                                        !checked && {
                                            color: '#d40020 !important',
                                            '& .MuiSvgIcon-root': {
                                                color: '#d40020 !important',
                                            },
                                        }),
                                }}
                            />
                        }
                        label={
                            <Typography variant="body2">
                                I understand the impact and have proper authorization to disable these Active Directory groups
                            </Typography>
                        }
                    />
                </Box>
            </Box>
        </Box>
    );
};

DisableSummary.propTypes = {
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            adGroup: PropTypes.string,
            adGroupOwner: PropTypes.string,
            members: PropTypes.arrayOf(PropTypes.object),
        })
    ),
    checked: PropTypes.bool.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    isTouched: PropTypes.bool,
};

DisableSummary.defaultProps = {
    groups: [],
    isTouched: false,
};

export default DisableSummary;
